module.exports = __webpack_public_path__ + "static/img/keep_package_active.24dea0b2.png";